// Reusable "click-outside to close" helper that doesn't fire when the user
// merely drag-selects text/numbers inside the modal and releases outside it.
//
// Bug pattern being fixed:  <div onClick={onClose}>   ← the backdrop
//   → mouseup after a text/number selection is registered as a click.
//   → user loses 5+ steps of wizard progress.
//
// Fix: only close if BOTH mousedown AND mouseup happen on the backdrop itself.

import { useRef } from 'react';

export function useBackdropClose(onClose) {
  const downOnBackdrop = useRef(false);
  return {
    onMouseDown: (e) => {
      downOnBackdrop.current = e.target === e.currentTarget;
    },
    onMouseUp: (e) => {
      if (downOnBackdrop.current && e.target === e.currentTarget) {
        onClose && onClose();
      }
      downOnBackdrop.current = false;
    },
    onTouchStart: (e) => {
      downOnBackdrop.current = e.target === e.currentTarget;
    },
    onTouchEnd: (e) => {
      if (downOnBackdrop.current && e.target === e.currentTarget) {
        onClose && onClose();
      }
      downOnBackdrop.current = false;
    },
  };
}
